import { cookie } from '@pdrj/pmi-iqos-shared-react'

export default class IqosphereCampaign {
  constructor(api) {
    this.api = api
  }

  getCampaign = async campaign => {
    const res = await this.api.get(
      `/iqosphere/campaign?campaignCode=${campaign}`,
      {
        headers: {
          ...cookie.authorizationTokenHeader()
        },
        mock: this.api.getMock('getCampaign')
      }
    )
    return res
  }
}
